export type FrameId =
  'player' | 'target' | 'party' | 'enemies' | 'cast' | 'swing' | 'meter';

/**
 * Where a frame sits on a screen of any size: an anchor of 0, ½ or 1 along each axis
 * (the same point on the frame and the screen), and the frame's offset from it in UI pixels.
 */
export type FramePos = { ax: number; ay: number; x: number; y: number };

type Size = { w: number; h: number };

const clamp = (v: number, max: number) => Math.min(Math.max(v, 0), max);
const third = (center: number, size: number) =>
  center < size / 3 ? 0 : center > (size * 2) / 3 ? 1 : 0.5;

/** The frame's top left, kept on screen. */
export function frameAt(pos: FramePos, frame: Size, screen: Size) {
  const freeW = Math.max(0, screen.w - frame.w);
  const freeH = Math.max(0, screen.h - frame.h);
  return {
    left: clamp(pos.ax * freeW + pos.x, freeW),
    top: clamp(pos.ay * freeH + pos.y, freeH),
  };
}

/** A dropped frame, anchored to the third of the screen its center is in. */
export function anchorFrame(
  left: number,
  top: number,
  frame: Size,
  screen: Size,
): FramePos {
  const freeW = Math.max(0, screen.w - frame.w);
  const freeH = Math.max(0, screen.h - frame.h);
  left = clamp(left, freeW);
  top = clamp(top, freeH);
  const ax = third(left + frame.w / 2, screen.w);
  const ay = third(top + frame.h / 2, screen.h);
  return {
    ax,
    ay,
    x: Math.round(left - ax * freeW),
    y: Math.round(top - ay * freeH),
  };
}
